import * as React from "react";

import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { LobFormWithTabs } from "components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";

interface TabbedWizardProps {
  wizardLOBs: FlexComponent[];
  context: any;
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tab: string) => void;
}

export const WizardTabbed = ({ wizardLOBs, context, wizardFormChildren, trackOnChangeTab }: TabbedWizardProps) => {
  return (
    <>
      <LobQueryRouter lobs={wizardLOBs} />

      <LobFormWithTabs
        context={context}
        lobForms={wizardFormChildren}
        wizardFormClassNames="all-x-padding-six"
        tabGroupClassNames="all-l-padding-six"
        trackOnChangeTab={trackOnChangeTab}
      />
    </>
  );
};
